import { MapTo } from '@adobe/aem-react-editable-components';
import RteComponent, { RteComponentEditConfig } from './RteComponent';

export default MapTo(
    'cob-corp-acquisition/components/creditonebank/rte-component',
)(RteComponent, RteComponentEditConfig);